import { useLocalStore } from '@kts-front/hooks';
import { Notifications } from '@mantine/notifications';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { withAuth } from 'hocs/withAuth';
import { LkLayoutStore, LkLayoutStoreProvider } from 'stores/local/layout/LkLayoutStore';
import { useDevices } from 'utils/devices';

import LkLayoutContent from './LkLayoutContent';
import UserNotificationsDrawer from './UserNotificationsDrawer';

export const LkLayout: React.FC = observer(() => {
  const { isDesktop } = useDevices();
  const { store } = useLocalStore(() => new LkLayoutStore({ isDesktop }));

  return (
    <LkLayoutStoreProvider store={store}>
      <Notifications position="top-center" limit={3} />
      <LkLayoutContent />
      <UserNotificationsDrawer />
    </LkLayoutStoreProvider>
  );
});

export default withAuth(LkLayout);
